import { render, staticRenderFns } from "./iconMapper.vue?vue&type=template&id=7267dc11&scoped=true"
import script from "./iconMapper.vue?vue&type=script&lang=js"
export * from "./iconMapper.vue?vue&type=script&lang=js"
import style0 from "./iconMapper.vue?vue&type=style&index=0&id=7267dc11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267dc11",
  null
  
)

export default component.exports